import api from "./index";

export async function createBreak(body) {
  return await api.post("/breaks", body);
}
export async function getBreaks(params) {
  return await api.get("/breaks", { params: params });
}
export async function getBreaksByID(id) {
  return await api.get(`/breaks/${id}`);
}
export async function editBreak(id, body) {
  return await api.put(`/breaks/${id}`, body);
}
export async function deleteBreak(id) {
  return await api.delete(`/breaks/${id}`);
}

export async function startBreak(body) {
  return await api.post("/people-breaks/start", { break: body });
}

export async function stopBreak(id) {
  return await api.put(`/people-breaks/stop/${id}`);
}

export async function getPeopleBreaks(params) {
  return await api.get("/people-breaks", { params: params });
}

export async function getPeopleBreakByID(id) {
  return await api.get(`/people-breaks/${id}`);
}
